import React from 'react';
import { motion } from 'framer-motion';
export function OfferBanner() {
  return <section className="py-20 px-6 bg-gold-900/30 border-y border-gold-500/20 relative overflow-hidden" data-id="element-72">
      {/* Background texture/noise */}
      <div className="absolute inset-0 bg-noise-overlay opacity-50 pointer-events-none" data-id="element-73" />

      <div className="container mx-auto max-w-4xl relative z-10 text-center" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-75">
          <h2 className="text-3xl md:text-4xl font-serif text-cream mb-6" data-id="element-76">
            Tu transformación comienza hoy con un{' '}
            <br className="hidden md:block" data-id="element-77" />
            <span className="text-gold-400 italic" data-id="element-78">beneficio exclusivo.</span>
          </h2>

          <p className="text-lg text-cream-muted font-light mb-10 max-w-2xl mx-auto" data-id="element-79">
            Queremos que vivas la experiencia MA por primera vez. Por eso, te
            obsequiamos un{' '}
            <strong className="text-gold-400 font-medium" data-id="element-80">
              10% DE DESCUENTO
            </strong>{' '}
            en todos nuestros servicios en tu primera visita.
          </p>

          <motion.a href="https://book.weibook.co/ma-barber-studio" target="_blank" rel="noopener noreferrer" className="inline-block bg-gold-500 hover:bg-gold-400 text-charcoal-900 font-bold py-4 px-10 rounded-sm transition-all duration-300 transform hover:scale-105 uppercase tracking-wider text-sm shadow-[0_0_30px_rgba(212,175,55,0.15)]" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-81">
            RESERVAR CITA CON 10% DTO
          </motion.a>
        </motion.div>
      </div>
    </section>;
}